export default function parseLanguageFromUrl() {
  // For testing, we can force the login language to change, keep this secret 🤫
  const searchParams = new URLSearchParams(
    document.location.search.substring(1),
  );
  return searchParams.get('language') || undefined;
}
